var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelsuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4977 7.50022L7.49754 12.5003M7.49754 7.50022L12.4977 12.5003M18.3311 10.0003C18.3311 14.6028 14.6001 18.3338 9.9976 18.3338C5.39511 18.3338 1.66406 14.6028 1.66406 10.0003C1.66406 5.3978 5.39511 1.66675 9.9976 1.66675C14.6001 1.66675 18.3311 5.3978 18.3311 10.0003Z",
    stroke: "#F04438",
    strokeWidth: 1.66671,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelsuccess);
export default __webpack_public_path__ + "static/media/cancelsuccess.40e3a31743f23424bb6eb9a3fdb6e85e.svg";
export { ForwardRef as ReactComponent };